import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PoliticaPrivacidad.css';

const PoliticaPrivacidad = () => {
  const navigate = useNavigate();

  return (
    <div className="pp-page">
      <div className="pp-hero">
        <button className="pp-back" onClick={() => navigate('/')}>
          <i className="fa-solid fa-arrow-left"></i> Volver al inicio
        </button>
        <div className="pp-hero-content">
          <i className="fa-solid fa-shield-halved pp-hero-icon"></i>
          <h1>Política de Privacidad y Protección de Datos Personales</h1>
          <p>Cash Sol S.A.C. — RUC N° 20604951268</p>
        </div>
      </div>

      <div className="pp-container">
        <div className="pp-card">

          <div className="pp-section">
            <div className="pp-section-header">
              <span className="pp-num">1</span>
              <h2>Identidad y Domicilio del Titular del Banco de Datos</h2>
            </div>
            <p>
              El titular del tratamiento de los datos personales es <strong>Cash Sol S.A.C.</strong>, identificado con RUC N° 20604951268, con domicilio fiscal en Av. Carlos Eyzaguirre Mza. a Lote. 18, Lima, Perú.
            </p>
          </div>

          <div className="pp-section">
            <div className="pp-section-header">
              <span className="pp-num">2</span>
              <h2>Banco de Datos</h2>
            </div>
            <p>
              Los datos de carácter personal recopilados a través de nuestro formulario de registro serán almacenados en nuestro banco de datos denominado <strong>"Usuarios del Portal Web"</strong>, el cual se encuentra registrado (o en proceso de inscripción) ante el Registro Nacional de Protección de Datos Personales de la Autoridad Nacional de Protección de Datos Personales (ANPD).
            </p>
          </div>

          <div className="pp-section">
            <div className="pp-section-header">
              <span className="pp-num">3</span>
              <h2>Finalidades Obligatorias del Tratamiento</h2>
            </div>
            <p>Cash Sol tratará sus datos personales con las siguientes finalidades estrictamente necesarias para la ejecución de la relación contractual o precontractual:</p>
            <ul>
              <li>Validar la identidad del Usuario ante el Registro Nacional de Identificación y Estado Civil (RENIEC).</li>
              <li>Evaluar el perfil crediticio, capacidad de pago y nivel de riesgo del Usuario, lo cual incluye realizar consultas en centrales de riesgo privadas (como Equifax/Infocorp).</li>
              <li>Gestionar la creación, mantenimiento y seguridad de su cuenta en el Portal.</li>
              <li>Gestionar el desembolso del préstamo, la facturación, el cobro de las cuotas y las acciones de cobranza en caso de atraso.</li>
              <li>Atender consultas, reclamos y solicitudes de soporte técnico.</li>
            </ul>
          </div>

          <div className="pp-section">
            <div className="pp-section-header">
              <span className="pp-num">4</span>
              <h2>Finalidades Opcionales (Comerciales)</h2>
            </div>
            <p>Solo si el Usuario otorga su consentimiento expreso marcando la casilla opcional en el registro, Cash Sol podrá tratar sus datos para:</p>
            <ul>
              <li>Enviar ofertas comerciales, promociones de créditos, publicidad de productos financieros propios o de socios estratégicos a través de correo electrónico, SMS, llamadas telefónicas o WhatsApp.</li>
            </ul>
          </div>

          <div className="pp-section">
            <div className="pp-section-header">
              <span className="pp-num">5</span>
              <h2>Transferencia y Flujo Transfronterizo de Datos</h2>
            </div>
            <p>Para cumplir con las finalidades descritas, Cash Sol podrá transferir sus datos a:</p>
            <ul>
              <li>Empresas de evaluación crediticia y Centrales de Riesgo (Ej. Sentinel Perú S.A.).</li>
              <li>Entidades financieras y pasarelas de pago para procesar los depósitos y recaudar las cuotas.</li>
              <li><strong>Proveedores de servicios en la nube (Hosting):</strong> Los datos pueden ser almacenados en servidores de terceros (como AWS, Google Cloud o Azure) ubicados fuera del Perú, lo que constituye un flujo transfronterizo de datos, garantizando niveles adecuados de seguridad.</li>
            </ul>
          </div>

          <div className="pp-section">
            <div className="pp-section-header">
              <span className="pp-num">6</span>
              <h2>Plazo de Conservación</h2>
            </div>
            <p>
              Los datos personales se conservarán mientras dure la relación contractual y, posteriormente, por un plazo de hasta cinco (5) años, de conformidad con las normas de prescripción legal en materia civil y financiera en el Perú. Si la solicitud de crédito es rechazada, los datos se conservarán por un periodo de 1 año para fines de auditoría y prevención de fraudes.
            </p>
          </div>

          <div className="pp-section">
            <div className="pp-section-header">
              <span className="pp-num">7</span>
              <h2>Ejercicio de Derechos ARCO</h2>
            </div>
            <p>
              El Usuario puede ejercer en cualquier momento sus derechos de Acceso, Rectificación, Cancelación y Oposición (Derechos ARCO) conforme a la Ley N° 29733. Para ello, deberá enviar una solicitud escrita adjuntando copia de su DNI al correo electrónico:
            </p>
            <a href="mailto:Cashsolperuclientes@gmail.com" className="pp-email">
              <i className="fa-solid fa-envelope"></i> Cashsolperuclientes@gmail.com
            </a>
          </div>

          <div className="pp-section">
            <div className="pp-section-header">
              <span className="pp-num">8</span>
              <h2>Modificaciones a la Política</h2>
            </div>
            <p>
              Cash Sol se reserva el derecho de modificar esta política para adaptarla a novedades legislativas. Cualquier cambio sustancial será notificado al Usuario a través del Portal o por correo electrónico antes de su entrada en vigor.
            </p>
          </div>

          <div className="pp-footer-note">
            <i className="fa-solid fa-circle-info"></i>
            Última actualización: 2025. Ley N° 29733 — Ley de Protección de Datos Personales del Perú.
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoliticaPrivacidad;
